import React, { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
/* import { createRoute } from "../../API/createRoute";
 */import toast from "react-hot-toast";
/* import { createShop, upDateShop } from "../../API/shop";
 */import { MdArrowBack } from "react-icons/md";
import { createEnquiry } from "../apis/enquiryApi";
/* import Loader from "../Loader"; */

const AddEnquiry = () => {
  const location = useLocation();
  const [enquiries, setEnquiries] = useState([]);
  const { shop, isEdit, isView } = location.state || {};
  const [formData, setFormData] = useState(
    shop || {
      _id:'',
      name: "",
       phone: "",
      email: "",
      location: "",
      address:"",
      Landsize:"",
      source:"",
      photos:"",
    enquiryDate:"",

      
    }
  );
  
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };


  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
  const previewUrls = files.map((file) => URL.createObjectURL(file));

    setFormData({ 
      ...formData, 
      photos: files, 
      photoPreviews: previewUrls 
    });
  };


  
const handleSubmit = async (e) => {
  e.preventDefault();

  // Validation
  if (!formData.name?.trim() || !formData.phone?.trim() || !formData.email?.trim()) {
    toast.error("Please fill in all required fields");
    return;
  }

  try {
    // Prepare FormData for API
    const formPayload = new FormData();
    formPayload.append("name", formData.name);
    formPayload.append("phone", formData.phone);
    formPayload.append("email", formData.email);
    formPayload.append("location", formData.location);
    formPayload.append("address", formData.address);
    formPayload.append("landSize", formData.Landsize);
    formPayload.append("source", formData.source);

    // Append photos if any
    if (Array.isArray(formData.photos)) {
      formData.photos.forEach((file) => formPayload.append("photos", file));
    }

    // Use the correct field for backend
    formPayload.append(
      "date",
      formData.enquiryDate || new Date().toISOString()
    );

    // Send to backend
    const response = await createEnquiry(formPayload, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response.success) {
      toast.success("Enquiry submitted successfully!");

      // Optionally, update local state to reflect new enquiry
      setEnquiries(prev => [...prev, response.data]);

      // Reset form
      setFormData({
        _id: '',
        name: "",
        phone: "",
        email: "",
        location: "",
        address: "",
        Landsize: "",
        source: "",
        photos: [],
        photoPreviews: [],
        enquiryDate: "",
      });

      // Navigate to enquiries list
      navigate("/enquiry");
    } else {
      toast.error(response.message || "Failed to create enquiry");
    }
  } catch (error) {
    console.error("Failed to submit enquiry:", error);
    toast.error("Failed to submit enquiry");
  }
};

  

  const today = new Date().toISOString().split("T")[0];
 return (
   <>
   {
   /*  loading?<Loader/>: */(
      <div className="p-8  bg-white rounded-lg shadow-md mt-[5%]">
      <button
        onClick={() => navigate(-1)}
        className="text-gray-700 flex space-x-1 hover:text-red-600 transition duration-200"
      >
        <MdArrowBack className="w-6 h-6 mt-1" />

        <h2 className="text-2xl font-semibold mb-4">
         {/*  {!shop ? "Add Enquiry" : isEdit ? "Edit Shop" : "View Shop"} */}
         Add Enquiry
        </h2>
      </button>
      <form
        onSubmit={handleSubmit}
        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {/* Property Type */}
       
 <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="name"
          >
             Name
          </label>
          <input
            id="name"
            type="text"
            value={formData.name}
            onChange={handleChange}
            disabled={isView}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            placeholder="Enter  name"
          />
        </div>
       <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="phone"
          >
            Phone
          </label>
          <input
            id="phone"
            type="number"
            value={formData.phone}
            disabled={isView}

            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            placeholder="Enter phone number"
          />
        </div>

  
        {/* Email */}
        <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="email"
          >
            Email ID (Optional)
          </label>
          <input
            id="email"
            type="email"
            value={formData.email || ""}
            disabled={isView}

            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            placeholder="Enter email address"
          />
        </div>
         <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="location"
          >
            Map Location
          </label>
          <input
            id="location"
            type="text"
            value={formData.location}
            disabled={isView}

            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            placeholder="Enter location"
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="address"
          >
           Address
          </label>
          <input
            id="address"
            type="text"
            value={formData.address}
            disabled={isView}

            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            placeholder="Enter address"
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="Landsize"
          >
            Land Size(sqft)
          </label>
          <input
            id="Landsize"
            type="number"
            value={formData.Landsize}
            onChange={handleChange}
            disabled={isView}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            placeholder="Enter Landsize"
          />
        </div>
        <div className="mb-4">
  <label className="block text-sm font-medium text-gray-700" htmlFor="source">
    Source
  </label>
  <select
    id="source"
    value={formData.source}
    onChange={handleChange}
    disabled={isView}
    className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
  >
    <option value="">Select Source</option>
    <option value="Social Media">Social Media</option>
    <option value="Franchise Visit">Franchise Visit</option>
    <option value="reference Visit">Reference Visit</option>
    <option value="direct">Direct</option>
    <option value="Status Visit">Stal Visit</option>
  </select>
</div>

<div className="mb-4">
      <label className="block text-sm font-medium text-gray-700" htmlFor="photos">
        Media
      </label>
      <input
        id="photos"
        type="file"
        multiple
        accept="image/*"
        disabled={isView}
        onChange={handleFileChange}
        className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
      />
   {Array.isArray(formData.photoPreviews) && formData.photoPreviews.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-2">
          {formData.photoPreviews.map((preview, index) => (
            <img 
              key={index} 
              src={preview} 
              alt={`Preview ${index}`} 
              className="w-5 h-5 object-cover rounded-md border" 
            />
          ))}
        </div>
      )}
    </div>

        <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="enquiryDate"
          >
            Enquiry Date
          </label>
          <input
            id="enquiryDate"
            type="date"
            value={formData.enquiryDate}
            max={today}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-sm"
            placeholder="Enter enquiryDate"
          />
        </div>

         {!isView && (
          <div className="col-span-full">
            <button
              type="submit"
              className="w-full py-2 px-4 bg-red-600 text-white rounded-lg shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-200"
            >
              {isEdit ? "Update Shop" : "Submit"}
            </button>
          </div>
        )}
      </form>
    </div>
    )
   }
   </>
  );
};

export default AddEnquiry